/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svchip_SwiftInputs */

const en_svchip_swift = /** @type {(inputs: Svchip_SwiftInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Swift`)
};

const ar_svchip_swift = /** @type {(inputs: Svchip_SwiftInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`سويفت`)
};

const bn_svchip_swift = /** @type {(inputs: Svchip_SwiftInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Swift`)
};

const de_svchip_swift = /** @type {(inputs: Svchip_SwiftInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Swift`)
};

const es_svchip_swift = /** @type {(inputs: Svchip_SwiftInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rápido`)
};

const fr_svchip_swift = /** @type {(inputs: Svchip_SwiftInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rapide`)
};

const pt_svchip_swift = /** @type {(inputs: Svchip_SwiftInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rápido`)
};

const zh_svchip_swift = /** @type {(inputs: Svchip_SwiftInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`斯威夫特`)
};

const tr_svchip_swift = /** @type {(inputs: Svchip_SwiftInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hızlı`)
};

const ru_svchip_swift = /** @type {(inputs: Svchip_SwiftInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Свифт`)
};

const pl_svchip_swift = /** @type {(inputs: Svchip_SwiftInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Szybki`)
};

/**
* | output |
* | --- |
* | "Swift" |
*
* @param {Svchip_SwiftInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
export const svchip_swift = /** @type {((inputs?: Svchip_SwiftInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svchip_SwiftInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svchip_swift(inputs)
	if (locale === "bn") return bn_svchip_swift(inputs)
	if (locale === "de") return de_svchip_swift(inputs)
	if (locale === "es") return es_svchip_swift(inputs)
	if (locale === "fr") return fr_svchip_swift(inputs)
	if (locale === "pt") return pt_svchip_swift(inputs)
	if (locale === "zh") return zh_svchip_swift(inputs)
	if (locale === "tr") return tr_svchip_swift(inputs)
	if (locale === "ru") return ru_svchip_swift(inputs)
	if (locale === "pl") return pl_svchip_swift(inputs)
	return en_svchip_swift(inputs)
});